import React from 'react';
import { Link } from 'react-router-dom';
import { BUSINESS } from '../../data/siteData';
import { PartsSearchForm } from '../ui/PartsSearchForm';

export default function HeroSection() {
  return (
    <section style={{ position: 'relative', minHeight: '100vh', display: 'flex', alignItems: 'center', background: 'var(--navy)', overflow: 'hidden' }}>
      {/* Background */}
      <div style={{
        position: 'absolute', inset: 0,
        background: `linear-gradient(135deg, rgba(13,27,42,0.96) 0%, rgba(26,46,66,0.88) 50%, rgba(13,27,42,0.82) 100%), url(https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1600&q=80) center/cover no-repeat`,
      }} />
      {/* Grid overlay */}
      <div className="grid-overlay" style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }} />
      {/* Left accent bar */}
      <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 4, background: 'linear-gradient(180deg, var(--orange), transparent)' }} />

      <div style={{
        position: 'relative', zIndex: 2,
        maxWidth: 1280, margin: '0 auto',
        padding: '80px 2rem 80px',
        display: 'grid',
        gridTemplateColumns: '1fr 420px',
        gap: '4rem', alignItems: 'center',
        width: '100%',
      }}
      className="hero-grid"
      >
        {/* Left content */}
        <div style={{ animation: 'fadeUp 0.7s both' }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
            background: 'rgba(232,84,26,0.15)', border: '1px solid rgba(232,84,26,0.3)',
            borderRadius: 100, padding: '0.3rem 0.9rem',
            fontFamily: '"Barlow Condensed"', fontSize: '0.75rem', fontWeight: 700,
            color: 'var(--orange-light)', letterSpacing: '0.1em', textTransform: 'uppercase',
            marginBottom: '1.5rem',
          }}>
            <span style={{ fontSize: '0.5rem' }}>●</span> Serving Brantford & Paris, ON
          </div>

          <h1 style={{
            fontFamily: '"Bebas Neue"',
            fontSize: 'clamp(3.5rem, 7vw, 6rem)',
            lineHeight: 0.95, color: 'white', letterSpacing: '0.02em', marginBottom: '1rem',
          }}>
            Quality Used<br />Auto Parts<br />
            <span style={{ WebkitTextStroke: '1px rgba(255,255,255,0.6)', color: 'transparent' }}>You Can Trust</span>
          </h1>

          <p style={{ fontSize: '1.15rem', fontWeight: 300, color: 'var(--silver-light)', lineHeight: 1.6, marginBottom: '2.5rem', maxWidth: 520 }}>
            Affordable, reliable parts for all makes & models — sourced locally, priced right, ready fast.
          </p>

          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', marginBottom: '3rem' }}>
            <Link to="/inventory" className="btn-primary">🔍 Search Parts</Link>
            <a href={`tel:${BUSINESS.phoneRaw}`} className="btn-outline">📞 Call Now</a>
          </div>

          <div style={{ display: 'flex', gap: '2.5rem', flexWrap: 'wrap' }}>
            {BUSINESS.stats.map(stat => (
              <div key={stat.label}>
                <div style={{ fontFamily: '"Bebas Neue"', fontSize: '2.2rem', color: 'white', lineHeight: 1 }}>{stat.num}</div>
                <div style={{ fontSize: '0.75rem', fontWeight: 500, color: 'var(--silver)', letterSpacing: '0.06em', textTransform: 'uppercase' }}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right: Quick Search Card */}
        <div style={{
          background: 'rgba(255,255,255,0.04)', backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255,255,255,0.1)', borderRadius: 16, padding: '2rem',
          animation: 'fadeUp 0.8s 0.3s both',
        }} className="hero-search-card">
          <h3 style={{ fontFamily: '"Bebas Neue"', fontSize: '1.5rem', color: 'white', letterSpacing: '0.05em', marginBottom: '1.25rem' }}>
            Quick Parts Search
          </h3>
          <PartsSearchForm dark compact />
          <p style={{ fontSize: '0.72rem', color: 'var(--silver)', textAlign: 'center', marginTop: '0.75rem' }}>
            Powered by CarParts.com database
          </p>
        </div>
      </div>

      <style>{`
        @media (max-width: 960px) {
          .hero-grid { grid-template-columns: 1fr !important; }
          .hero-search-card { display: none !important; }
        }
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}
